import React from 'react';
import {
  Form, Row, Col, Select, Button, message, Input, Modal,Icon
} from 'antd';
import FileBase64 from 'react-file-base64';
import img from './../../assets/img/Illustration.png';
import MiCompAPI from '../../util/api';
const { Option } = Select;

class FD extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loas: [],
      carriers: [],
      usstates:[],
      loa:null,
      isupload: false,
      strfile_Name:''

    }
    this.api = new MiCompAPI(this.props.userPermandMasters);

  }
  componentDidMount = () => {
    this.getClientMasters();
  }
  getClientMasters() {
    this.api.invoke(
      "GetMasters",
      "post",
      (data, success) => {
        if (success) {
          this.setState({
            loas: data.lobs,
          });
        }
      },
      ["LOB"]
    );
  }
  getCarries = (e) => {

    this.api.invoke(
      "GetContractCarrierByLoa/" + this.state.loa+"/"+e,
      "get",
      (data, success) => {
        if (success) {
          this.setState({
            carriers: data.data,
          });
        }
      }

    );
  }
  GetStatebyLoAState = (e) => {
    const { decodedToken } = this.props.userPermandMasters;
    var role = decodedToken.UserRoleName;
   if (role !== "carrier"){

    this.api.invoke(
      "GetStatebyLoAState/" + e,
      "get",
      (data, success) => {
        if (success) {
          this.setState({
loa:e,
            usstates: data.data
          });
        }
      }

    );
   }

  }
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {

      if (!err) {
        if (this.fileData&&this.state.strfile_Name) {
          if (this.fileData.file.size > 2097152) {
            message.warning("File size must under 2MiB!", 3);
          }
          // else if (this.fileData.name.split('.')[1] !== 'xls' && this.fileData.name.split('.')[1] !== 'xlsx') {
          //   message.error("Invalid file format!, Plese upload file.", 10)
          // }
          else {
            this.props.submitHandler({ ...values,strDoc_Name: this.fileData.name ,strfile_Name:this.state.strfile_Name, st_base64_file: this.fileData.base64 }, (val) => {
              if (!val) {
              }
            });
          }
        } else {

          message.error("Plese enter file name and upload file.", 10)
        }
      }
    });
  }
  handleAddDocument = (data) => {

    if (data.file.size > 2097152) {
      message.warning("File size must under 2MiB!", 3);
    }
    // if (data.name.split('.')[1] !== 'xls' && data.name.split('.')[1] !== 'xlsx') {
    //   message.error("Invalid file format!, Plese upload file.", 10)
    // }
    this.fileData = data;
  }
  docChange=(e)=>{

    this.setState({strfile_Name:e.target.value});
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="mi_model_popup">
        <Row span={24}>
          <Col span={18}>
            <p className='mi_title'>{this.props.title}</p>
          </Col>
          <Col span={6}>
            <i className="fa fa-times mi_icon mi_icon_red mi_button_close" style={{ color: 'red' }} onClick={this.props.closeDrawerHandler} ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>
            <Col sm={24}>
              <Form.Item>
                <fieldset className="mi_fieldset2 mi_input_pop">
                  <legend className="legend-font">Quote Name</legend>
                  {getFieldDecorator('quote_Name', {
                    rules: [{ required: true, message: 'Please enter Quote Name.' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s()]+$/,
                      message: "It allows only Alphanumerics"
                    }],
                  })(<Input type="text" maxLength={40} autoComplete={"nope"}  className="mi_input" placeholder="Enter Quote Name *" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col sm={24}>
              <Form.Item>
                <fieldset style={{ height: 'auto' }} className="mi_fieldset2 mi_input_pop">
                  <legend className="legend-font">Quote Description</legend>
                  {getFieldDecorator('quote_Description', {
                    rules: [{ required: true, message: 'Please enter Quote Description.' }, {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s()]+$/,
                      message: "It allows only Alphanumerics"
                    }],
                  })(<Input.TextArea type="text" style={{ height: '100px' }} autoComplete={"nope"}  className="mi_input" placeholder="Enter Quote Description *" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col sm={24}>
              <Form.Item>
                <fieldset className="mi_fieldset2 mi_input_pop">
                  <legend className="legend-font">LOA</legend>
                  {getFieldDecorator('loa', {
                    rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select LOA. </span> }],
                  })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input"
                    optionFilterProp="children"
                    showSearch={true}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={this.GetStatebyLoAState}

                    placeholder="Please Select LOA *">
                    {this.state.loas ? this.state.loas.map(tag => <Option value={tag.name} key={tag.name}>{tag.name}</Option>) : ""}
                  </Select>)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col sm={24}>
            <Form.Item>
                    <fieldset className="mi_fieldset2 mi_input_pop">
                      <legend className="legend-font">State</legend>
                      {getFieldDecorator('state', {
                        rules: [{ required: false, message: 'Please select State' }],
                      })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input"
                        showSearch={true}
                        optionFilterProp="children"
                        onChange={this.getCarries.bind(this)}

                        filterOption={(input, option) =>
                          option.props.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        } className="mi_input" placeholder="Please Select State"  >
                        {this.state.usstates.map(tag => <Option value={tag.name} key={tag.name}>{tag.name}</Option>)}
                      </Select>)}
                    </fieldset>
                  </Form.Item></Col>
            <Col sm={24}>
              <Form.Item>
                <fieldset className="mi_fieldset2 mi_input_pop">
                  <legend className="legend-font">Carrier </legend>
                  {getFieldDecorator('carriers', {
                    rules: [{ required: true, message: <span style={{ marginTop: '-6px !important' }}> Please select Carrier . </span> }],
                  })(<Select suffixIcon={<Icon style={{transform:'rotate(90deg)'}} type="double-right" />} className="mi_input"
                    optionFilterProp="children"
                    showSearch={true}
                    mode="multiple"

                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    placeholder="Please Select Carrier *">
                    {this.state.carriers ? this.state.carriers.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>) : ""}
                  </Select>)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
            {this.state.isupload ? <Modal visible={this.state.isupload}  >
              <div className="mi_model_popup" style={{paddingBottom:"22px"}}>
                <Row span={24}>
                  <Col md={12} sm={24} >
                    <fieldset  className="mi_fieldset2 mi_input_pop" style={{margin:"12px 20px"}}>
                      <legend className="legend-font">Document Name</legend>
                      {getFieldDecorator('strDoc_Name', {
                      })(<Input value={this.state.strDoc_Name} onChange={this.docChange} type="text" maxLength={40} autoComplete={"nope"}  className="mi_input" placeholder="Enter Document Name" />)}
                    </fieldset>
                  </Col>
                  <Col md={12} sm={24} >
                    <fieldset className="mi_fieldset2 mi_input_pop" style={{margin:"12px 20px"}}>
                      <legend className="legend-font">Document File</legend>
                      <div >
                        <FileBase64 onDone={this.handleAddDocument} />

                      </div>
                    </fieldset>

                  </Col></Row>
                <Row span={24} style={{ marginTop: '20px' }}>
                  <Col span={5}></Col>
                  <Col span={14}>
                    <Button type="primary" onClick={() => this.setState({ isupload: false })} >
                      Cancel
                    </Button>
                    <Button type="primary" onClick={() => this.setState({ isupload: false })} >
Submit
                    </Button>
                  </Col>
                  <Col span={5}>
                    <img alt="example" style={{ width: 105, marginBottom: '-20px', float: 'right' }} src={img} />
                  </Col>
                </Row>
              </div>                    </Modal> : ""}
          <Row span={24}>
            <Col sm={24}>
            <Col md={12} sm={24} style={{ marginTop: '20px',marginLeft:'-3px' }}>
                                    <Button onClick={() => this.setState({ isupload: true })}>Upload Documents </Button>

                                </Col>
            </Col>
            <Col md={12} sm={24}>
            </Col>
          </Row>
          <Row span={24} style={{ marginTop: '20px' }}>
            <Col span={7}></Col>
            <Col span={5}>
              <Button className="mi_button_right" onClick={this.props.closeDrawerHandler} style={{ marginRight: 8 }}>
                Cancel
              </Button>
            </Col>
            <Col span={5}>
              <Button htmlType="submit" type="primary" >
                Submit
              </Button>
            </Col>
            <Col span={7}>
              <img alt="example" style={{ width: 105, marginBottom: '-29px', float: 'right' }} src={img} />
            </Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const AddQuoteDrawer = Form.create()(FD);
export default AddQuoteDrawer;